export const commonIconProps = {
    svgSize: {type: Number, default: 18},
    svgActive: {type: Boolean},
    svgName: String,
    svgColor: {type: String, default: 'var(--joy-color-neutral-60)'},
};
